import tablelistApi from 'api/tablelistApi'

export default {
  /**
   * @param {Object} options
   */
  create(options) {
    if (!options) throw new Error('options is required')

    return tablelistApi.post('/admission-group-request', options)
  },
}



// WEBPACK FOOTER //
// ./src/api/admissionGroupRequest/service.js